import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import Button from "../../../../components/Common/Button";
import {professionScopes} from "../../../../db/datasets/professions";
import {DatasetEntryI} from "../../../../db/models/dataset";
import {updateUser} from "../../../../api/user";
import "./style.scss";

interface Props {
    // step: number;
    handleGoNext: Function;
    // handleGoBack: Function;
}

const StudentInterest = ({handleGoNext}) => {
    const {t} = useTranslation();
    const [interestScopes, setInterestScopes] = useState<DatasetEntryI[]>([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const min = 1;
    const max = 5;

    useEffect(()=>{
        const parentClass = document.getElementById("mainContentInGrid")
        if (parentClass) parentClass.style.backgroundColor = "#03193e";
        return () => {
            if (parentClass) parentClass.style.removeProperty("background-color");
        }
    },[])

    const onInterestSelect = (scope: DatasetEntryI) => {
        const found = interestScopes.find((s) => s.id === scope.id);

        if (interestScopes.length >= max && !found) return;

        if (found)
            setInterestScopes([...interestScopes.filter((s) => s.id !== scope.id)]);
        else setInterestScopes([...interestScopes, scope]);
    };

    const onSubmit = async () => {
        if (interestScopes.length < min || interestScopes.length > max) {
            setError(true);
            return;
        }

        const interests = interestScopes.map((s) => s.id);

        try {
            setLoading(true);
            await updateUser({interestScopes: interests});
            setLoading(false);
            handleGoNext();
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    };

    return (
        <div className="studentOnboardingInterest oval-borders p-2">
            <div className="p-2 studentOnboardingInterest__title text-white">
                {t("student_onboarding_interest_title")}
            </div>
            {/* <div className="studentOnboardingInterest__subtitle">
				{t("student_onboarding_interest_subtitle", { min, max })}
			</div> */}
            <div className="studentOnboardingInterest__grid">
                {professionScopes.map((scope) => (
                    <div
                        key={scope.id}
                        className={`
                        studentOnboardingInterest__interest 
						${
                            interestScopes.find((s) => s.id === scope.id)
                                ? "studentOnboardingInterest__interest--active"
                                : ""
                        }
                        ${
                            interestScopes.length >= max
                                ? "studentOnboardingInterest__interest--disable"
                                : ""
                        }
                    `}
                        onClick={() => onInterestSelect(scope)}
                    >
                        {t(scope.label)}
                    </div>
                ))}
            </div>
            {error && (
                <p className="error">
                    {t("student_onboarding_interest_error", {min, max})}
                </p>
            )}
            <div className="p-3 mb-4 text-center">
                {/* <Button
					type="button"
					onClick={handleGoBack}
					loading={loading}
					borderColor="#3392E8"
				>
					{t("student_onboardingSchool_backBtn")}
				</Button> */}
                <Button
                    className={"w-100"}
                    type="button"
                    onClick={onSubmit}
                    filled
                    loading={loading}
                    backgroundColor="#3392E8"
                    borderColor="#3392E8"
                >
                    {t("student_onboarding_nextBtn")}
                </Button>
            </div>
        </div>
    );
};

export default StudentInterest;
